import AssessmentTool from "../components/assessment/AssessmentTool";
import { useParams } from "react-router-dom";

export default function AssessmentToolPage() {
  const { projectId } = useParams();
  return <AssessmentTool projectId={projectId} />;
}